<template lang="html">
  <div id="alert_box" class="alert_box" v-show="shareVisible">
    <div class="alert" v-show="alertMod">
      <div class="share_else">
        <div class=""  @click="btnVX()">
          <img src="../assets/image/vx.png" alt="">
          <span>微信好友</span>
        </div>
        <div class="" @click="btnQQ()">
          <img src="../assets/image/qq.png" alt="">
          <span>QQ好友</span>
        </div>
        <div class="" @click="btnVX_home()">
          <img src="../assets/image/vx_moments.png" alt="">
          <span>朋友圈</span>
        </div>
        <div class="" @click="btnQQ_home()">
          <img src="../assets/image/Qkone.png" alt="">
          <span>QQ空间</span>
        </div>
        <div class="" @click="btnVB()">
          <img src="../assets/image/microblog.png" alt="">
          <span>微博</span>
        </div>
      </div>
      <div class="cancel" @click="cancel()">
        取消
      </div>
    </div>

    <!-- 浮层 -->
    <div class="reminder" v-show="reminder" @click="reminderBtn()">
      <img src="../assets/image/reminder.png" alt="">
    </div>
  </div>
</template>

<script>
import utils from '@/utils/utils.js';

export default {
  props: ["shareVisible", "detailUrl"],
  data(){
    return {
      alertMod: true,
      reminder: false,
      succeed : [],
    }
  },
  mounted(){

  },
  methods:{
    /* 微信 */
    btnVX(){
      if(utils.browserChecker.isWx() || utils.browserChecker.isMobileQQ()){
        this.reminder = true;
        this.alertMod = false;
      }else{
        const input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', this.detailUrl)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
        }
        document.body.removeChild(input)
        utils.showMessage('活动链接已复制')
      }
    },
    /* QQ */
    btnQQ(){
      if(utils.browserChecker.isWx() || utils.browserChecker.isMobileQQ()){
        this.reminder = true;
        this.alertMod = false;
      }else{
        const input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', this.detailUrl)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
        }
        document.body.removeChild(input)
        utils.showMessage('活动链接已复制')
      }
    },
    /* VX朋友圈 */
    btnVX_home(){
      if(utils.browserChecker.isWx() || utils.browserChecker.isMobileQQ()){
        this.reminder = true;
        this.alertMod = false;
      }else{
        const input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', this.detailUrl)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
        }
        document.body.removeChild(input)
        utils.showMessage('活动链接已复制')
      }
    },
    /* QQ空间 */
    btnQQ_home(){
      if(utils.browserChecker.isWx() || utils.browserChecker.isMobileQQ()){
        this.reminder = true;
        this.alertMod = false;
      }else{
        const input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', this.detailUrl)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
        }
        document.body.removeChild(input)
        utils.showMessage('活动链接已复制')
      }
    },
    /* 微博 */
    btnVB(){
      if(utils.browserChecker.isWx() || utils.browserChecker.isMobileQQ()){
        this.reminder = true;
        this.alertMod = false;
      }else{
        const input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', this.detailUrl)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
        }
        document.body.removeChild(input)
        utils.showMessage('活动链接已复制')
      }
    },
    reminderBtn(){
      this.reminder = false;
      this.alertMod = true;
      this.$emit('shareCancel')
    },
    cancel () {
      this.$emit('shareCancel')
    },
  }
}
</script>

<style lang="css" scoped>
.alert_box{
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
	z-index: 21;
}
.alert{
  width: 100%;
  height: 165px;
  background-color: #ffffff;
  border-radius: 20px 20px 0 0;
  position: fixed;
  bottom: 0;
}
.share_else{
  box-sizing: border-box;
  width: 100%;
  padding-top: 25px;
  padding-bottom: 10px;
  display: flex;
  overflow-x: auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.share_else div{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 15px;
  font-size: 11px;
}
.share_else div img{
  width: 50px;
  height: 50px;
}
.share_else div span{
  margin-top: 8px;
}
.cancel{
  width: 100%;
  height: 54px;
  line-height: 54px;
  text-align: center;
}
/* 海报 */
.posterAlert{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
}
.poster{
  width: 290px;
  height: 370px;
  background-color: #ffffff;
  padding: 15px 18px;
  box-sizing: border-box;
}
#posterLogo{
  width: 60px;
  height: 22px;
}
.poster_banner{
  object-fit: cover;
  height: 180px;
  margin-top: 15px;
}
.poster_banner img{
  width: 100%;
  height: 100%;
}
.poster_ma{
  display: flex;
  margin-top: 20px;
  color: #3F454B;
  font-size: 11px;
}
.poster_ma_download{
  border-right: 1px solid #DDDDDD;
}
.poster_ma_qun{
  border-left: 1px solid #DDDDDD;
}
.poster_ma div{
  width: 50%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.poster_ma div img{
  width: 60px;
  height: 60px;
}
.poster_maApp{
  color: #E50120
}
.poster_download{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  font-size: 11px;
  color: #FFFFFF;
}
.poster_download img{
  width: 46px;
  height: 46px;
}
.poster_download p {
  margin-top: 8px;
}
.reminder{
  height: 100%;
}
.reminder img{
  width: 100%;
}

@media (min-width: 750px) {
  #alert_box{
    width: 750px;
    margin: 0 auto;
  }
  .alert{
    width: 750px;
  }
}
</style>
